module.exports = __webpack_public_path__ + "static/media/new-capa4.212f9825.png";